/**
 * Formik-specific form block
 */

import FormBlock from "../FormBlock";
import { Input } from "..";
import React from "react";
import { getError } from "../../lib/form";
import subformShape from "../../shapes/subformShape";

const CompanyInfo = ({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
  intl
}) => (
  <FormBlock titleId="wizard.companyInfo" key="CompanyInfo" smallTitle={true}>
    <Input
      type="text"
      name="company.name"
      label={intl.formatMessage({
        id: "wizard.companyInfo.name.label"
      })}
      value={values.company.name}
      error={getError(touched, errors, "company.name")}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <Input
      type="text"
      name="company.businessId"
      label={intl.formatMessage({
        id: "wizard.companyInfo.businessId.label"
      })}
      value={values.company.businessId}
      error={getError(touched, errors, "company.businessId")}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <Input
      type="text"
      name="company.address"
      label={intl.formatMessage({
        id: "wizard.companyInfo.address.label"
      })}
      value={values.company.address}
      error={getError(touched, errors, "company.address")}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <div className="ContactInfo__doubleInput">
      <Input
        className="ContactInfo__doubleInput__left"
        type="text"
        name="company.postalCode"
        label={intl.formatMessage({
          id: "wizard.companyInfo.postalCode.label"
        })}
        value={values.company.postalCode}
        error={getError(touched, errors, "company.postalCode")}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        className="ContactInfo__doubleInput__right"
        type="text"
        name="company.postOffice"
        label={intl.formatMessage({
          id: "wizard.companyInfo.postOffice.label"
        })}
        value={values.company.postOffice}
        error={getError(touched, errors, "company.postOffice")}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  </FormBlock>
);

CompanyInfo.propTypes = subformShape;

export default CompanyInfo;
